module.exports = __webpack_public_path__ + "img/urenregistratie-icon.1bf0e17.png";